import React from 'react';
import './style.scss';
import {Popup} from '../../../../components';
import popupTaskResultSuccess from '../../../../../images/popup-task-result-success.png';
import popupTaskResultError from '../../../../../images/popup-task-result-error.png';

export const PopupTaskResult = ({success, title, text, onClose}) => {
 return <Popup
      title={title}
      buttonText={'Закрыть'}
      onClose={onClose}
  >
   {success && <img src={popupTaskResultSuccess} alt="" className="app-popup-task-result--image app-popup-task-result--image_success"/>}
   {!success && <img src={popupTaskResultError} alt="" className="app-popup-task-result--image app-popup-task-result--image_error"/>}
   <div className="app-popup--description" dangerouslySetInnerHTML={{__html: text}}/>
  </Popup>;
}